import {
  pluginImage,
  pluginVideo,
  pluginFileUpload,
  pluginDivider,
  pluginHtml,
  pluginCodeBlock,
  pluginGiphy,
  pluginEmoji,
  pluginVerticalEmbed,
  pluginLink,
  pluginLinkPreview,
  pluginTextColor,
  pluginTextHighlight,
  pluginHashtag,
  pluginMentions,
  pluginSpoiler,
  pluginCollapsibleList,
  pluginPoll,
} from '@wix/ricos';

import { PLUGINS } from '@wix/communities-forum-client-commons';

export const editorPluginModules = {
  [PLUGINS.IMAGE]: pluginImage,
  [PLUGINS.VIDEO]: pluginVideo,
  [PLUGINS.FILE_UPLOAD]: pluginFileUpload,
  [PLUGINS.GIPHY]: pluginGiphy,
  [PLUGINS.EMOJI]: pluginEmoji,
  [PLUGINS.CODE_BLOCK]: pluginCodeBlock,
  [PLUGINS.COLLAPSIBLE_LIST]: pluginCollapsibleList,
  [PLUGINS.DIVIDER]: pluginDivider,
  [PLUGINS.HTML]: pluginHtml,
  [PLUGINS.VERTICAL_EMBED]: pluginVerticalEmbed,
  [PLUGINS.LINK]: pluginLink,
  [PLUGINS.LINK_PREVIEW]: pluginLinkPreview,
  [PLUGINS.TEXT_COLOR]: pluginTextColor,
  [PLUGINS.TEXT_HIGHLIGHT]: pluginTextHighlight,
  [PLUGINS.HASHTAG]: pluginHashtag,
  [PLUGINS.MENTIONS]: pluginMentions,
  [PLUGINS.SPOILER]: pluginSpoiler,
  [PLUGINS.POLLS]: pluginPoll,
};
